import { getUsageLimitsHelpUrl } from '@/components/constants/billing-urls';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

/** The clinician seat checkout that sits between the T-7 modal and Stripe. */
export const CLINICIAN_UPGRADE_CHECKOUT_PATH = '/settings/billing/clinician-upgrade';

export const BILLING_SETTINGS_PATH = '/settings/billing';

export function useOpenClinicianCheckout(): () => void {
  const router = useRouter();
  return useCallback(() => {
    void router.push(CLINICIAN_UPGRADE_CHECKOUT_PATH);
  }, [router]);
}

export function useOpenBillingSettings(): () => void {
  const router = useRouter();
  return useCallback(() => {
    void router.push(BILLING_SETTINGS_PATH);
  }, [router]);
}

// The yearly offer has no conditions article of its own yet; the usage limits
// article stands in until marketing publishes one.
export const getOfferConditionsUrl = (locale?: string): string =>
  getUsageLimitsHelpUrl(locale);
